/* ══════════════════════════════════════════════════════════════
   Monthly Heatmap — Calendar Heatmap (green/red months)
   ══════════════════════════════════════════════════════════════ */

export interface MonthlyReturn {
    year: number;
    month: number;
    returnPct: number;
}

export function renderMonthlyHeatmap(container: HTMLElement, returns?: MonthlyReturn[]): void {
    const data: MonthlyReturn[] = returns || [
        { year: 2024, month: 3, returnPct: 2.1 }, { year: 2024, month: 4, returnPct: -0.8 },
        { year: 2024, month: 5, returnPct: 1.5 }, { year: 2024, month: 6, returnPct: 3.2 },
        { year: 2024, month: 7, returnPct: -1.2 }, { year: 2024, month: 8, returnPct: 0.9 },
        { year: 2024, month: 9, returnPct: 2.8 }, { year: 2024, month: 10, returnPct: -2.1 },
        { year: 2024, month: 11, returnPct: 1.4 }, { year: 2024, month: 12, returnPct: 0.6 },
        { year: 2025, month: 1, returnPct: 3.5 }, { year: 2025, month: 2, returnPct: 1.8 },
    ];

    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const years = [...new Set(data.map(d => d.year))].sort();

    const getColor = (r: number) => {
        if (r >= 3) return '#059669';
        if (r >= 1) return '#10b981';
        if (r >= 0) return '#6ee7b7';
        if (r >= -1) return '#fca5a5';
        if (r >= -3) return '#ef4444';
        return '#dc2626';
    };

    let grid = '<div class="hm-row"><div class="hm-cell hm-header"></div>';
    for (let m = 1; m <= 12; m++) grid += `<div class="hm-cell hm-header">${months[m]}</div>`;
    grid += '</div>';

    for (const year of years) {
        grid += `<div class="hm-row"><div class="hm-cell hm-year">${year}</div>`;
        for (let m = 1; m <= 12; m++) {
            const entry = data.find(d => d.year === year && d.month === m);
            if (entry) {
                grid += `<div class="hm-cell hm-value" style="background:${getColor(entry.returnPct)}; color: white">${entry.returnPct >= 0 ? '+' : ''}${entry.returnPct.toFixed(1)}%</div>`;
            } else {
                grid += '<div class="hm-cell hm-empty">—</div>';
            }
        }
        grid += '</div>';
    }

    const positiveMonths = data.filter(d => d.returnPct > 0).length;
    const avgReturn = (data.reduce((s, d) => s + d.returnPct, 0) / data.length).toFixed(2);

    container.innerHTML = `
    <div class="monthly-heatmap glass-card">
      <div class="card-header">
        <h3>📆 Monthly Returns</h3>
        <span>${positiveMonths}/${data.length} positive months · Avg: ${avgReturn}%</span>
      </div>
      <div class="hm-grid">${grid}</div>
    </div>`;
}
